module.exports = __webpack_public_path__ + "images/fifth_anniversary/step1-Img_240b6ad2db563d1fb4e308af9ae1192c.png";